module.exports = __webpack_public_path__ + "media/images/employed_inactive-4c8048fd.svg";